import { Button, Grid, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useLogoutMutation } from "../../api/api-hooks";
import { useAppDispatch } from "../../app/hooks";
import { useAuth } from "../../hooks/useAuth";
import { setCredentials } from "./authSlice";
import logo from "./logoCompressed.webp";

const Logout = () => {
  const { user } = useAuth();
  const [logout] = useLogoutMutation();
  const dispatch = useAppDispatch();
  const { push } = useHistory();
  // Logout of API
  if (user !== null) logout({ id: user.id });
  // Logout of client app
  dispatch(setCredentials({ user: null, token: "" }));
  localStorage.clear();
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <img src={logo} alt="LP Technologies Logo" />
      </Grid>
      <Grid item>
        <Typography>You have successfully logged out.</Typography>
      </Grid>
      <Grid item>
        <Button
          onClick={() => {
            push("/login");
          }}
          variant="contained"
          color="primary"
        >
          Log In
        </Button>
      </Grid>
    </Grid>
  );
};

export default Logout;
